module.exports = __webpack_public_path__ + "static/media/instagram.adbb8645.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/Footer/assets/instagram.svg
// module id = 40
// module chunks = 0